var React = require('react');

function IconFooter (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 32.0002C0 14.3272 14.3268 0 31.9998 0C49.6732 0 64 14.3272 64 32.0002H0Z","fill":"#0B1C63","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 32C0 49.673 14.3268 63.9998 31.9998 63.9998C49.6732 63.9998 64 49.673 64 32H0Z","fill":"#1D46E3","key":1})]);
}

IconFooter.defaultProps = {"width":"64","height":"64","viewBox":"0 0 64 64","fill":"none"};

module.exports = IconFooter;

IconFooter.default = IconFooter;
